import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export class CreateNationalEventForm {
  public name: string = '';
  public localName: string = '';
  public date: string = '';
  public isFixedDate: boolean = true;
  public movableMethod: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    name: [
      (v: string) => !!v || 'Name field is required.',
    ],
    localName: [
      (v: string) => !!v || 'Local name field is required.',
    ],
    date: [
      (v: string) => !!v || 'Date field is required.',
    ],
    isFixedDate: [
      (v: string) => !!v || 'This field is required.',
    ],
    movableMethod: [
      (v: string) => !!v || 'This field is required.',
    ],
  };
}
